export const copyToClipboard = (text = "", event, callbackNotify, callbackText) => {
  navigator.clipboard.writeText(text);
  callbackNotify(callbackText ? callbackText : "Référence copiée");
  event.stopPropagation();
};
